export default __webpack_public_path__ + "static/media/solution_41.e30baabb.svg";